import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Download, FileText } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

export default function Downloads() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocs = async () => {
      const token = localStorage.getItem('userToken');
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        const res = await axios.get(`${API_URL}/api/my-applications`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const apps = res.data;
        let docsList = [];
        
        apps.forEach(app => {
          if (app.status === 'Complete' && Array.isArray(app.processed_documents)) {
            app.processed_documents.forEach(doc => {
              // Extract extension from original_filename or storage_path
              const ext = doc.original_filename.split('.').pop() || 'pdf';
              // File name should be sub category service name
              const displayFilename = `${app.sub_category_name}.${ext}`;
              
              docsList.push({
                ...doc,
                displayFilename,
                application_number: app.application_number,
                sub_category_name: app.sub_category_name,
                category_name: app.category_name,
                created_at: app.created_at
              });
            });
          }
        });
        
        setDocuments(docsList);
      } catch (err) {
        console.error(err);
        toast.error('માહિતી લાવવામાં નિષ્ફળતા');
      } finally {
        setLoading(false);
      }
    };
    fetchDocs();
  }, []);

  const token = localStorage.getItem('userToken');

  if (!token) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] font-sans flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center p-4">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-[#E2E8F0] text-center max-w-md">
            <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4 text-[#172554]">
              <Download className="w-8 h-8" />
            </div>
            <h2 className="text-xl font-bold text-[#172554] text-gujarati mb-2">લૉગિન જરૂરી છે</h2>
            <p className="text-[#64748B] text-sm text-gujarati mb-6">
              તમારા દસ્તાવેજો ડાઉનલોડ કરવા માટે કૃપા કરીને લૉગિન કરો.
            </p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans flex flex-col">
      <Header />
      <main className="flex-1 px-4 md:px-24 py-8 w-full max-w-5xl mx-auto">
        <h2 className="text-2xl font-bold text-[#172554] text-gujarati mb-6 border-b-2 border-[#F5B800] pb-2 inline-block">
          ડાઉનલોડ (Downloads)
        </h2>
        <p className="text-[#64748B] text-sm text-gujarati mb-6">
          અહીં તમારા તમામ પૂર્ણ થયેલ અરજીઓના પ્રોસેસ કરેલા દસ્તાવેજો ઉપલબ્ધ છે.
        </p>

        {loading ? (
          <div className="py-10 text-center text-[#172554]">Loading...</div>
        ) : documents.length === 0 ? (
          <div className="bg-white p-8 rounded-lg shadow-sm border border-[#E2E8F0] text-center text-[#64748B] text-gujarati">
            કોઈ દસ્તાવેજો ડાઉનલોડ માટે ઉપલબ્ધ નથી.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {documents.map((doc, idx) => {
              const API_URL = process.env.REACT_APP_BACKEND_URL;
              // Add auth query param for downloading secure files if we implemented it, but currently it's public path.
              // Still using the direct link, but downloading with the correct filename.
              return (
                <div key={idx} className="bg-white p-4 rounded-lg shadow-sm border border-[#E2E8F0] flex items-center justify-between gap-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center shrink-0">
                      <FileText className="w-5 h-5 text-green-600" />
                    </div>
                    <div className="flex flex-col min-w-0">
                      <span className="font-bold text-[#172554] text-gujarati truncate">
                        {doc.displayFilename}
                      </span>
                      <span className="text-xs text-[#64748B]">
                        App No: {doc.application_number}
                      </span>
                    </div>
                  </div>
                  
                  <a 
                    href={`${API_URL}/api/files/${doc.storage_path}`}
                    target="_blank" rel="noreferrer"
                    download={doc.displayFilename}
                    className="shrink-0 bg-green-600 text-white p-2 rounded-full hover:bg-green-700 transition-colors"
                    title="Download"
                  >
                    <Download className="w-4 h-4" />
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
